module.exports = __webpack_public_path__ + "img/shhy.cd3ed082.jpg";